export const en = {
  'classification failed': 'Classification failed',
  'lung parenchyma attenuation classification fail':
    'Lung parenchyma attenuation classification fail',
  'lung parenchyma segmentation fail': 'Lung parenchyma segmentation fail',
  'segmentation failed': 'Segmentation failed',
  // rad: 'Radiography',
  // tom: 'Tomography without contrast',
  // tomc: 'Contrast tomography',
  Abnormal: 'Abnormal',
  attention: 'Attention',
  actions: 'Actions',
  add: 'Add',
  addANewAdministrator: 'Add a new administrator',
  addAnImageFile: 'Add an image file',
  addExams: 'Add Exams',
  adding: 'Adding',
  addLogo: 'Add logo',
  administrator: 'Administrator',
  administratorDetails: 'Administrator details',
  administratorAlreadyRegistered: 'The administrator is already registered in another institution',
  addNewExam: 'Add new exam',
  addNewRegister: 'Add new register',
  addNewUnit: 'Add new unit',
  addNewInstitution: 'Add new institution',
  address: 'Address',
  admUser: 'Administrator',
  administratorData: 'Administrator Data',
  age: 'Age',
  agreeWithResultsAi: 'Do you agree with the results from HealthSCAN AI?',
  all: 'All',
  and: 'and',
  andGetInTouchWithUs: 'and get in touch with us',
  angio: 'Angio',
  annotation: 'Annotation module',
  annotationSentSuccessfully: 'Annotation sent successfully.',
  app: 'Approved',
  resetFilters: 'Reset filters',
  approve: 'Approve',
  abdomen: 'Abdomen',
  approveResults: 'Approve results',
  approveReports: 'Approve reports',
  approved: 'Approved',
  approvedResults: 'Approved results',
  ar: 'Autorefraction',
  areYouSureDeleteExam: 'Are you sure you want to delete the exam?',
  areYouSureAgreeWithResultsByAi:
    'Are you sure that you agree with results generated by HealthSCAN AI?',
  asmt: 'Content Assessment Results',
  attachPrintToHelpUnderstandWhatsHappening:
    'Attach one or more print screens to help us understand what is happening',
  attachment: 'Attachment',
  Autorefraction: 'autorefraction',
  afterConfirmationTheExamDeleted: 'After confirmation, the exam will be completely excluded from the exam.',
  au: 'Audio',
  back: 'Back',
  background: 'Background',
  bdus: 'Bone Densitometry (ultrasound)',
  bi: 'Biomagnetic imaging',
  bmd: 'Bone Densitometry (X-Ray)',
  bmi: 'BMI',
  bodyHeight: 'Body Height',
  bodyPart: 'Body part',
  bodyWeight: 'Body weight',
  brain: 'Brain',
  cancel: 'Cancel',
  canOnlyAddOneImage: 'You can only add one image',
  changeAdminInstitution: 'Change admin Institution',
  changePassword: 'Change password',
  checkYourEmailAndTypeInTheField:
    'Check your email and type or paste in the field below',
  city: 'City',
  chest: 'Chest',
  clickHere: 'click here',
  cnpjAlreadyRegistered: 'The CNPJ is already registered in another institution',
  comments: 'Comments',
  complement: 'Complement',
  confirm: 'Confirm',
  confirmEmail: 'You need to confirm your email',
  consolidation: 'Consolidation',
  continue: 'Continue',
  country: 'Country',
  covidModule: 'COVID module',
  cpfAlreadyRegistered: 'CPF already registered',
  cpfMustBeValid: 'CPF must be valid',
  cr: 'Computed Radiography',
  ct: 'Computed Tomography',
  cnn: 'Display CNN Report',
  cyst: 'Cyst',
  dashboard: 'Dashboard',
  data: 'Data',
  delete: 'Delete',
  deleteexam: 'Delete Exam',
  density: 'density',
  densityControl: 'Density Control',
  description: 'Description',
  densitometry: 'Display Densitometry Report',
  dg: 'Diaphanography',
  diameter: 'Diameter',
  diffuse: 'Diffuse',
  donwload: 'Donwload',
  doc: 'Document',
  docUser: 'Doctor',
  doctorsName: "Doctor's name",
  dontWorryYouCanGoTo: "Don't worry, you can go to ",
  view3dModel: 'View 3D model',
  downloadReport: "Download relatório",
  dx: 'Digital Radiography',
  ecg: 'Electrocardiography',
  edit: 'Edit',
  edition: 'Edition module',
  editSucess : 'Edit successfully completed 200',
  editUser: 'Edit user',
  emailAlreadyRegistered: 'E-mail already registered',
  emailConfirmation: 'Email confirmation',
  emailConfirmedSuccessfully: 'Email confirmed successfully',
  emailFieldIsRequired: 'Email field is required',
  emphysema: 'Emphysema',
  enter: 'Enter',
  enterInstitutionAddress: 'Enter institution address',
  enterInstitutionName: 'Enter institution name',
  enterYourName: 'Enter your name',
  enterAMessage: 'Enter a message',
  eps: 'Cardiac Electrophysiology',
  err: 'Unprocessed',
  inc: 'Inconclusive',
  errorApprovingReport: 'Error approving the report',
  errorConfirmingEmail: 'Error confirming email. Please try again',
  errorDisapprovingReport: 'Error disapproving report',
  errorRegisteringInstitution: 'Error registering institution. Please try again.',
  errorRegisteringExam: 'Error registering exam. Please try again.',
  errorRequestingExamUpdate: 'Error requesting exam update. Please try again.',
  errorSubmittingYourReview: 'Error submitting your review',
  errorTryingToLoadInitialDataTryingLoadAgain:
    'Erro ao tentar carregar os dados iniciais. Tentando carregar novamente.',
  errorReadingDicomData: 'Error extracting data from DICOM files.',
  errorUploadingDicomFile: 'Error uploading DICOM file',
  errorWhenSendingTheAnnotation:
    'Error when sending the annotation. Please try again.',
  errorWhenSendingTheSegmentation:
    'Error when sending the segmentation. Please try again.',
  es: 'Endoscopy',
  examDate: 'Exam Date',
  examRegistration: 'Registration Date',
  examDescription: 'Exam description',
  examImagesNotAvailableYet: 'Exam images not available yet',
  examPanel: 'Exam panel',
  examType: 'Exam type',
  exameType: 'Exame Type',
  exampleEmail : 'example@email.com',
  exam: 'exam',
  exams: 'exams',
  examsPanel: 'exams panel',
  examsPerMonth: 'exams per month',
  examsThisMonth: 'Exams this month',
  examUpdateRequestedSuccessfully: 'Exam update requested successfully, please wait a few minutes.',
  exitWithoutSaving: 'Are you sure you want to leave this page? Any unsaved exams will be lost.',
  extractingDataFromDicomFiles: 'Extracting data from DICOM files',
  extractingImagesFromDicomFiles: 'Extracting images from DICOM files',
  f: 'Female',
  fid: 'Fiducials',
  filterByExamType: 'Filter by exam type',
  filterExamByStatus: 'Filter exam by status',
  filterExamsByDoctor: 'Filter exams by doctor',
  filterExamsByPatient: 'Filter exams by patient',
  forgotMyPassword: 'I forgot my password',
  frequency: 'frequency',
  from1To4ImageFiles: 'from 1 to 4 image files',
  generalSuport: 'General suport',
  gm: 'General Microscopy',
  goToExamsPanel: 'Go to Exams Panel',
  hc: 'Hard Copy',
  hd: 'Hemodynamic Waveform',
  headquarters: 'Headquarters',
  healthscanPlan: 'HealthSCAN Plan',
  help: 'help',
  helpPage: 'help page',
  high: 'high',
  highAttenuation: 'High attenuation',
  highFemale: 'high',
  howCanWeHelpYou: 'How can we help you?',
  inc: 'Inconclusive',
  iIsYourFirstAccess: 'If this is your first access',
  ifYouNeedSupportGoToThe: 'If you are in need of support, go to the',
  ifYouWantChangeItPleaseGetTouchWithUs:
    'If you want to change it, please get in touch with us',
  ifYouWantReplaceMainAccountAdminContactUs:
    'If you want to replace the main account administrator, please contact us',
  image: 'image',
  imageNotAvailable: 'Image not available',
  images: 'images',
  insertMatriculation: 'Insert registration',
  inscription: 'Inscription',
  information: 'Information',
  informations: 'Informations',
  insertRegistry: 'Insert registry',
  institution: 'institution',
  Institution: 'Institution',
  institutions: 'institutions',
  institutionDetails: 'Institution details',
  institutionRegistration: 'Institution Registration',
  institutionsTitle: 'Institutions',
  institutionSuccess: 'Institution successfully added',
  invalidEmail: 'Invalid e-mail',
  invalidEmailOrPassword: 'Invalid e-mail or password',
  invalidField: 'Invalid field',
  invalidFieldMaximum250Characters: 'Invalid field. Maximum 250 characters',
  invalidFieldMaximum50Characters: 'Invalid field. Maximum 50 characters',
  invalidFieldMustHave11Numbers: 'Invalid field. Must have 11 numbers',
  invalidFieldMustHave14Numbers: 'Invalid field. Must have 14 numbers',
  invalidFieldMustHave8Numbers: 'Invalid field. Must have 8 numbers',
  invalidNumber: 'Invalid number',
  invalidValue: 'Invalid value',
  invertContrast: 'Invert color',
  io: 'Intra-Oral Radiography',
  iol: 'Intraocular Lens Data',
  itsNotPossibleSendMoreThan4ImagesByEmail:
    "It's not possible to send more than 4 images by email",
  ivoct: 'Intravascular Optical Coherence Tomography',
  ivus: 'Intravascular Ultrasound',
  ker: 'Keratometry',
  ko: 'Key Object Selection',
  len: 'Lensometry',
  loadingInstitutionList: 'Loading institution list...',
  loadingInstitutionSummary: 'Loading headquarters information...',
  loading3DModel: 'Loading 3D model...',
  loadingExamImages: 'Loading exam images...',
  loadingPDF: 'Loading PDF...',
  loadingExamInfo: 'Loading exam information...',
  loadingExamSummaryAndFilters: 'Loading exam summary and filters...',
  loadingRegisteredDoctors: 'Loading registered doctors',
  loadingRegisteredInstitutions: 'Loading registered institutions',
  logoImage: 'Logo Image',
  low: 'low',
  lung: 'Lung',
  lowAttenuation: 'Low attenuation',
  lowFemale: 'low',
  limits: 'Limits',
  ls: 'Laser surface scan',
  m: 'Male',
  makeYourLogin: 'Make your login',
  matriculation: 'Matriculation',
  medicalAssistant: 'Medical Assistant',
  medicalRecord: 'Medical Record',
  message: 'Message',
  mg: 'Mammography',
  mild: 'Mild',
  modality: 'Modality',
  model3dNotAvailableYet: '3D model not available yet',
  moderate: 'Moderate',
  mr: 'Magnetic Resonance',
  mustSelectAdministrator: 'You must select or add an administrator',
  myprofile: 'My profile',
  name: 'Name',
  nameTooLong: 'Name is too long',
  nameRepportExamToSaveAs: 'Name repport exam to save as',
  new: 'New',
  newAdministratorError: 'Error adding a new administrator',
  newAdministratorSuccess: 'Administrator successfully added',
  newer: 'Newer Exam Date',
  next: 'Next',
  niftiError: 'The tool is not available for this exam because was not possible to convert the series to NIfTI volume',
  nm: 'Nuclear Medicine',
  normal: 'Normal',
  Normal: 'Normal',
  normalAttenuation: 'Normal attenuation',
    notifications: 'Notifications',
  notificationViewed: 'OPENED',
  notificationNotViewed: 'OPEN',
  noResults: 'No results',
  noActiveUser : 'It seems we cannot find any active user based on your search.',
  noChanges: 'No alteration',
  noResultsDescription: 'It seems we cannot find any results based on your search.',
  noUpdatesAvailable: 'No updates available at the moment.',
  number: 'Number',
  numberOfExams: 'Number of Exams',
  o: 'Other',
  outros: 'Others',
  oam: 'Ophthalmic Axial Measurements',
  oct: 'Optical Coherence Tomography (non-Ophthalmic)',
  older: 'Older Exam Date',
  op: 'Ophthalmic Photography',
  opacity: 'Opacity',
  operatorImage: 'Operator Image',
  opm: 'Ophthalmic Mapping',
  opt: 'Ophthalmic Tomography',
  pro: 'Processing',
  opv: 'Ophthalmic Visual Field',
  overwriteExistingAnnotations: 'Overwrite',
  sort: 'Sort',
  oss: 'Optical Surface Scan',
  ot: 'Other',
  our: 'our',
  ourOfficeHoursAre:
    'Our office hours are Monday through Friday, 9 am to 5 pm Eastern, and we attempt to respond to support requests within 1 business day.',
  ohifError: 'Unable to display the viewer because the exam may have been deleted or is unavailable on the image server',
  observation: 'Observation',
  pageNotFound: 'Page not found',
  panelControl: 'Panel control',
  patUser: 'Patient',
  pathology: 'Pathology',
  patient: 'Patient',
  patientInformation: 'Patient Information',
  patientName: 'Patient Name',
  patientsName: "Patient's name",
  patientId: 'Patient ID',
  patient_name_asc: 'Patient name (A-Z)',
  patient_name_desc: 'Patient name (Z-A)',
  performance: 'Performance',
  plan: 'Plan',
  pleaseFillOutThisFormToGetInTouch:
    'Please, fill out this form to get in touch',
  postalCode: 'Postal code',
  pr: 'Presentation State',
  previous: 'Previous',
  privacyPolicy1: 'PRIVACY POLICY\n\n\
                  Hello! Just like you, we care about privacy! After all, privacy is a right provided for in the ',
  brazilianConstitution: 'Brazilian Constitution',
  privacyPolicy2: '  .\
                  Therefore, Meditec (Medical Digital Imaging Technologies Ltda.) respects your privacy regarding any \
                  information we may collect.\n\n\
                  It is important to remember that our website may contain links to external sites that we do not operate. \
                  Please be aware that we have no control over the content and practices of these sites and cannot accept \
                  responsibility or liability for their respective privacy policies.\n\n\
                  1. What types of data do we collect?\n\n\
                  We receive, collect, and store any information you enter on our website or provide to us \
                  in any other way. We also collect the IP address used to connect your computer to the \
                  Internet and other computer and Internet information. We may use tools to measure and \
                  collect navigational information, including page response times, length of visits to \
                  certain pages, page interaction information, and methods to browse away from the page.\n\n\
                  We also collect personally identifiable information (such as name, email, and preferred communication method).\n\n\
                  2. How do we collect this personal data?\n\n\
                  When you register on our website, as part of the procedure, we collect the personal information you provide, \
                  such as your name, telephone number, and email address. We will only use your personal information for \
                  the purposes outlined below. \n\n\
                  3. Why do we collect this personal data?\n\n\
                  We only ask for personal information when we truly need it to provide a service to you, with your knowledge \
                  and consent. In short, we collect this data to provide legal services (including one-off consultancies) and \
                  draft legal contracts and documents, provide our clients with ongoing legal assistance and support, be able \
                  to contact our Visitors and Users with general or personalized notices related to the service provided, create \
                  aggregated statistical data and other aggregated and/or inferred non-personal information, which we or our \
                  business partners may use to provide and improve our respective services, comply with any applicable laws and regulations.\n\n\
                  4. Where do we store, share or use the data?\n\n\
                  The information collected is used and stored in the cloud for two years and is only shared with third-party legal \
                  entities or partner doctors. We do not publicly share personally identifiable information with third parties except \
                  when required by law.\n\n\
                  5. How do we communicate with our customers and website visitors?\n\n\
                  We may contact you to notify you or clarify any information related to the service we provide; \
                  to help you resolve any issue related to the service provided; to inform you about invoices, including through a \
                  third party company; for surveys or questionnaires; for updates about our activities or for any other reason that \
                  is necessary to review our contract, by local laws. For this purpose, we may contact you via email, telephone, \
                  text messages, and/or mail.\n\n\
                  COOKIE POLICY\n\n\
                  1. What are cookies?\n\n\
                  As is common practice with almost all professional websites, this site uses cookies (tiny files downloaded to your computer) \
                  to improve your experience. This page describes what information they gather, how we use it, and why we sometimes need to store \
                  these cookies. We will also share how you can prevent these cookies from being stored. However, this may downgrade or break \
                  certain site functionality elements.\n\n\
                  2. How do we use cookies?\n\n\
                  We use cookies for several reasons, which are detailed below. Unfortunately, in most cases, there are no industry standard \
                  options for disabling cookies without completely disabling the functionality and features they add to this site. We recommend \
                  leaving on all cookies if you are unsure whether you need them in case they are used to provide a service you use.\n\n\
                  3. Disable cookies\n\n\
                  You can prevent cookies from being set by adjusting the settings on your browser (see your browser\'s Help for instructions). \
                  However, disabling cookies will affect the functionality of this and many other websites you visit. It will usually \
                  also disable certain functionality and features of this site. Therefore, we recommend that you do not disable cookies. \
                  The following links explain how to access cookie settings in various browsers:\n\n\
                  ',
  firefoxCookieConfig: 'Cookie Settings in Firefox',
  explorerCookieConfig: 'Cookie Settings in Internet Explorer',
  exportData: 'Export data',
  chromeCookieConfig: 'Cookie Settings in Google Chrome',
  safariOSXCookieConfig: 'Cookie Settings in Safari (OS X)',
  safariOSCookieConfig: 'Cookie Settings in Safari (iOS)',
  androidCookieConfig: 'Cookie Settings on Android',
  privacyPolicy3: '',
  privacyPolicy4: ' to opt out of being tracked by Google Analytics across all websites.\
                  \n\nPRIVACY POLICY UPDATES\n\n\
                  We reserve the right to modify this privacy policy anytime, so please review it regularly. Changes will be effective \
                  immediately upon posting on our website. If we make material changes to this policy, we will notify you here so you \
                  know what information we collect and how we use it.\n\n\
                  MORE INFORMATION\n\n\
                  If you no longer want us to be able to collect your personal information, please contact us via email: \
                  contato@petrec.com.br .\n\n\
                  If you have any questions about this Privacy Policy, or would like to access, correct, or delete any information we have \
                  collected about you, please feel free to contact us by email at contato@petrec.com.br .',
  privacyPolicyTitle: 'Privacy Policy',
  privacyPolicyDescription: 'This Privacy Policy is meant to help you understand what information we collect, why we collect it, \
                              and how you can update, manage, export, and delete this information.',
  processing: 'Processing',
  pt: 'Positron emission tomography (PET)',
  pdfError: 'The PDF file could not be displayed because the exam may have been deleted or the file is unavailable on the server.',
  pulmonaryInvolvementExtent: 'Pulmonary Involvement Extent',
  pulmonaryInvolvementSeverity: 'Pulmonary Involvement Severity',
  px: 'Panoramic X-Ray',
  quantitiveAnalysis: 'Quantitive Analysis',
  radiographies: 'Radiographies',
  readingDicomData: 'Extracting data from DICOM files',
  reg: 'Registration',
  register: 'Register',
  registerAdministrator: 'Register Administrator',
  registrationDate: 'Registration date',
  registerSomeObservation: 'Register some observation about the exam (optional)',
  registered: 'registered',
  registeringExam: 'Registering exam',
  registrations: 'Registrations',
  registration_newer: 'Newer registration date on HealthScan',
  registration_older: 'Older registration date on HealthScan',
  registry: 'Accession number',
  report: 'Report',
  reportNotApprovedBecauseItHasFeedback:
    'Report not approved because it already has feedback',
  reportSuccessfullyApproved: 'Report successfully approved',
  reportSuccessfullyDisapproved: 'Report successfully disapproved',
  reports: 'Reports',
  requestReview: 'Request review',
  evaluation: 'evaluation',
  evaluations: 'Evaluations',
  noEvaluations: 'No evaluations found for this report.',
  justifications: 'Justifications',
  anonymous: 'Anonymous',
  save: 'Save',
  saving: 'Saving...',
  errorUpdatingFeedback: 'Error updating evaluation.',
  errorDeletingFeedback: 'Error deleting evaluation.',
  confirmDeleteFeedback: 'Are you sure you want to delete this evaluation?',
  requiredField: 'This field is required',
  changeReview: 'Change review',
  resUser: 'Responsible',
  resp: 'Respiratory Waveform',
  responsible: 'Responsible',
  result: 'Result',
  rev: 'Reviewed',
  rf: 'Radio Fluoroscopy',
  rg: 'Radiographic imaging (conventional film/screen)',
  rtdose: 'Radiotherapy Dose',
  rtimage: 'Radiotherapy Image',
  rtplan: 'Radiotherapy Plan',
  rtrecord: 'RT Treatment Record',
  rtstruct: 'Radiotherapy Structure Set',
  rwv: 'Real World Value Map',
  saveYourAnnotationAs: 'Save your annotation as',
  saveYourSegmentationAs: 'Save your segmentation as',
  scanQrCode: 'Scan QR code',
  searchExamByMedicalRecordPacient:
    'Search exams by medical record, name of pacient…',
  searchUser: "Search users",
  searchClass: "Search a class",
  seeLess: 'See less',
  seeMore: 'See more',
  seeResults: 'See results',
  seg: 'Segmentation',
  segmentationSentSuccessfully: 'Segmentation sent successfully',
  selectATopic: 'Select a topic',
  selectAClass: 'Select a class',
  selectAnOption: 'Select an option',
  selectImagesToRegisterExams: 'Select images to register exams',
  selectInstitution: 'Select institution',
  selectInstitutionToRegisterExams: 'Select institution to register exams',
  selectOneOrMoreOptionsToGetBetterResults:
    'Select one or more options that it should require more attention to get better results',
  selectHeadquarters: 'Select headquarters',
  selectAdministrator: 'Select an administrator',
  searchInstitutions: "Search institutions",
  selectUserType : 'Select a user type',
  sendFeedback: 'Send feedback',
  seriesWithoutDescription: 'Series without description',
  serieDescription: 'Series Description *',
  serieDescriptionWithoutAsterisk: 'Series Description',
  series_uid: 'Series UID',
  severe: 'Severe',
  sex: 'Sex',
  sm: 'Slide Microscopy',
  smr: 'Stereometric Relationship',
  sr: 'SR Document',
  srf: 'Subjective Refraction',
  stain: 'Automated Slide Stainer',
  status: 'Status',
  submit: 'Submit',
  tecUser: 'Technician',
  telephone: 'Telephone',
  tellMoreAboutDisagreeInResults:
    'Tell us more about what you disagree in the results',
    termsOfService: 'GENERAL TERMS AND CONDITIONS OF USE OF HEALTHSCAN\n\
    ----\n\
    OVERVIEW\n\n\
    The legal entity provides healthscan services with the following corporate name/business name: Meditec - Medical \
    Digital Imaging Technologies Ltda., trading as MEDITEC, registered with the CNPJ under nº. 45.144.055/0001-03, holder \
    of the intellectual property rights over the software, website, applications, content, and other assets related to the \
    Healthscan platform.\n\n\
    SECTION 1 - PURPOSE\n\n\
    The platform aims to license the use of its software, website, applications, and other intellectual property assets. \
    It provides tools to assist and streamline its users\' daily lives. The platform provides the following service: \
    software for analyzing exam images to facilitate diagnosis.\n\n\
    SECTION 2 - ACCEPTANCE\n\n\
    These Terms establish obligations freely and voluntarily contracted for an indefinite period between the platform \
    and the individuals or legal entities that use the software. By using the platform, the user fully accepts these rules \
    and undertakes to observe them at the risk of applying the applicable penalties. Acceptance of these terms is \
    essential for accessing and using any services provided by the company. If the user does not agree with the provisions \
    of these terms, they must not use the platform.\n\n\
    SECTION 3 - ACCESS TO USERS\n\n\
    All technical solutions available to the platform\'s owner will be used to allow access to the service 24 (twenty-four) \
    hours a day, 7 (seven) days a week. However, browsing the platform or its pages may be interrupted, limited, or suspended \
    for updates, modifications, or any action necessary for proper functioning.\n\n\
    (If registration is required to use the platform)\n\n\
    SECTION 4 - REGISTRATION\n\n\
    Access to the platform\'s features will require prior registration and, depending on the services or products chosen, \
    payment of a certain amount.\n\n\
    The user must provide complete, recent, and valid data when registering. It is their sole responsibility to keep this \
    data up to date, and they undertake to ensure the veracity of the data provided.\n\n\
    The user undertakes not to provide their registration and/or platform access data to third parties and is fully responsible \
    for any use made of them.\n\n\
    Minors under 18 and those without full civil capacity must obtain express consent from their legal guardians to use the platform \
    and its services or products. Access by minors and those without full civil capacity without prior authorization is the latter\'s \
    sole responsibility.\n\n\
    By registering, the user expressly declares and guarantees that he/she is fully capable and can freely exercise and use the services \
    and products.\n\n\
    The user must provide a valid email address for the website to carry out all necessary communications.\n\n\
    After confirming the registration, the user will have a login and a personal password, guaranteeing individual access to the site. \
    Therefore, the user\'s sole responsibility is to keep the password confidential and secure, preventing unauthorized access to personal information.\n\n\
    Any activities carried out using the password will be the user\'s responsibility, who must promptly inform the platform in case of \
    improper use of the respective password.\n\n\
    The account is personal and non-transferable and may not be assigned, sold, rented, or transferred in any way.\n\n\
    The user is responsible for ensuring that his/her equipment is compatible with the technical characteristics that enable the \
    platform and the services or products to be used.\n\n\
    The user may, at any time, request the cancellation of his/her registration with the software. Your registration will be \
    canceled as quickly as possible, provided that no outstanding debts are found.\n\n\
    By accepting the Terms and Privacy Policy, the user expressly authorizes the platform to collect, use, store, process, \
    transfer, or utilize information derived from the use of the services, the website, and any platforms. This includes all \
    information filled in by the user when registering or updating their registration and other information expressly described \
    in the Privacy Policy, which the user must authorize.\n\n\
    SECTION 5 - SERVICES\n\n\
    The platform may make a specific set of features and tools available to the user to optimize the use of the services. On the \
    platform, the services offered are described and presented with the highest degree of accuracy, containing information about \
    their characteristics, qualities, quantities, composition, price, warranty, expiration dates, and origin, among other data, \
    as well as about the risks they pose to the user\'s health and safety. Before finalizing the purchase of a given service, \
    the user must find out about its specifications and intended use. The delivery of services on the platform will be informed \
    when finalizing the purchase.\n\n\
    SECTION 6 - PRICES\n\n\
    The platform reserves the right to unilaterally readjust, at any time, the prices of services or products without prior \
    consultation or consent from the user. The values ​​applied are those in effect at the time of the order. Prices are indicated \
    in reais, specified separately, and informed to the user before finalizing the order. When contracting a service or product, \
    the platform may request the user\'s financial information, such as CPF, billing address, and card details. By entering said \
    data, the user agrees to be charged, according to the payment method chosen, at the prices then in effect and informed at the \
    time of contracting. We may store financial data to facilitate future access and contracting. The contracting of the services \
    will be automatically renewed by the platform, regardless of communication to the user, with periodic charges using the same \
    payment method indicated when contracting the service.\n\n\
    SECTION 7 - CANCELLATION\n\n\
    The user may cancel the contracting of the services by the terms defined at the time of contracting. Furthermore, the user may \
    cancel the services within 7 (seven) days after contracting by contacting Meditec, per the Consumer Protection Code (Law nº. 8,078/90). \
    The service may be canceled by:\n\n\
    a) the user: under these conditions, the services will only cease when the cycle in force at the time of cancellation has concluded;\n\
    b) Terms of Use violation: the services will cease immediately.\n\n\
    (If there is an exchange and refund clause)\n\n\
    SECTION 8 - SUPPORT\n\n\
    In case of any doubt, suggestion, or problem with using the platform, the user may contact support via email \
    at contato@petrec.com.br. These user support services will be available on the following days and times: Monday \
    to Friday from 9:00 am to 6:00 pm.\n\n\
    SECTION 9 - RESPONSIBILITIES\n\n\
    It is the user\'s responsibility: \n\
    a) technical defects or faults originating in the user\'s system; \n\
    b) the correct use of the platform and the services offered, valuing good coexistence, respect and cordiality among users;\n\
    c) compliance with and respect for the set of rules outlined in these General Terms and Conditions of Use, in the respective \
    Privacy Policy, and national and international legislation;\n\
    d) protection of the access data to your account/profile (login and password).\n\n\
    The Healthscan platform is responsible for:\n\
    a) indicating the characteristics of the service;\n\
    b) defects and faults found in the service provided, provided that it has caused them;\n\
    c) the information that has been disclosed by it, with comments or information disclosed by users being the sole responsibility \
    of the users themselves;\n\
    d) illegal content or activities carried out through its platform.\n\n\
    The platform is not responsible for external links in its system that may redirect users to an environment outside its network. \
    External links or pages that serve commercial or advertising purposes or any illegal, violent, controversial, pornographic, xenophobic, \
    discriminatory, or offensive information may not be included.\n\n\
    SECTION 10 - COPYRIGHT\n\n\
    These Terms of Use grant users a non-exclusive, non-transferable, and non-sublicensable license to access and use the platform and the \
    services and products made available by it.\n\n\
    The structure of the website or application, the brands, logos, trade names, layouts, graphics and interface design, images, illustrations, \
    photographs, presentations, videos, written and sound and audio content, computer programs, databases, transmission files, and any other \
    information and intellectual property rights of the company Meditec - Medical Digital Imaging Technologies Ltda., in compliance with the \
    terms of the Industrial Property Law (Law nº. 9,279/96), Copyright Law (Law nº. 9,610/98) and Software Law (Law nº. 9,609/98), are duly \
    reserved.\n\n\
    These Terms of Use do not grant or transfer any rights to the user, so access does not generate any intellectual property rights to the \
    user, except for the limited license granted herein.\n\n\
    The platform\'s use by the user is personal, individual, and non-transferable. Any unauthorized use, whether commercial or non-commercial, \
    is prohibited. Such uses violate Meditec Medical Digital Imaging Technologies Ltda.\'s intellectual property rights, which are punishable \
    under the applicable legislation.\n\n\
    SECTION 11 - PENALTIES\n\n\
    Without prejudice to other applicable legal measures, the company Meditec - Medical Digital Imaging Technologies LTDA. may, at any time, \
    warn, suspend, or cancel the user\'s account:\n\n\
    a) who violates any provision of these Terms;\n\
    b) who fails to comply with their user duties;\n\
    c) who engages in fraudulent, willful, or offensive behavior against third parties.\n\n\
    SECTION 12 - TERMINATION\n\n\
    Failure to comply with the obligations agreed upon in these Terms of Use or the applicable legislation may, without prior notice, result in immediate, \
    unilateral termination by Meditec—Medical Digital Imaging Technologies Ltda. and blocking of all services provided to the user.\n\n\
    SECTION 13 - CHANGES\n\n\
    Meditec—Medical Digital Imaging Technologies Ltda. may unilaterally and at any time change the items described in this instrument to adapt \
    or modify the services and meet new legal requirements. The changes will be published on the HEALTHSCAN app website, and if a user is a \
    subscriber to any service, the user may choose to accept the new content or cancel the use of the services. \n\n\
    (If services are offered to subscribers)\n\n\
    SECTION 14 - PRIVACY POLICY\n\n\
    In addition to these Terms, the user must consent to the provisions of the respective Privacy Policy, which will be presented to \
    all interested parties within the platform interface.\n\n\
    SECTION 15 - JURISDICTION\n\n\
    Brazilian law will be fully applied to resolve disputes arising from this instrument.\n\n\
    Any disputes must be filed in the district courts where the company is headquartered.\n\n\
    Questions about the Terms of Service should be sent to us at contato@petrec.com.br.',
  termsOfServiceTitle: 'Terms and conditions of use',
  termsOfServiceDescription: 'Please read our terms carefully and download the file in PDF format if necessary.',
  tg: 'Thermography',
  theEmailMustBeValid: 'The email must be valid',
  theFieldIsRequired: 'The field is required',
  theNameFieldiSRequired: 'The name field is required',
  theseAreInfoYourHealthscanPlan:
    'These are the informations of your HealthSCAN Plan',
  thisFieldIsRequired: 'This field is required',
  thisSoftware: 'This software is currently in the testing phase. Therefore, it is not yet available for commercial use.\n\
  We appreciate your patience and collaboration during this period.\n\
  We are working to enhance the user experience and address any identified issues. \n\
  If you encounter any bugs or have feedback, please let us know via email:',

  thisMonth: 'This month',
  toGetBackToNavigation: 'to get back to navigation',
  today: 'Today',
  tomographies: 'Tomographies',
  topic: 'Topic',
  torax: 'Thorax',
  totalExamsResults: 'Total exams results',
  tryGoingBackOrVisit: 'Try going back to the previous page or visit',
  type: 'Type',
  typeFieldsToContinue:
    'To continue, fill in the fields below with your email and password.',
  typeYourEmail: 'Enter your e-mail',
  typeYourFeedback: 'Type your feedback',
  typeYourPassword: 'Enter your password',
  typedAddressIncorrectly:
    'You may have typed the address incorrectly or the page may have been removed',
  undefined: 'Undefined',
  uploadFiles: 'Upload Files',
  updateResults: 'Update Results',
  uploadPath: 'Upload Path',
  uploaded: 'uploaded',
  uploading: 'uploading',
  uploadingDicomFilesToTheServer: 'Uploading the DICOM files to the server',
  us: 'Ultrasound',
  userPermissionsError : "it is mandatory to define at least one permission.",
  noInstutionBodyInfo: 'This user is currently not linked to any institution. Contact your system administrator to link the user and enable access permissions',
  va: 'Visual Acuity',
  viewSeries : 'View series',
  viewStudy: "View study",
  waitingAuthorization: 'Waiting authorizantion',
  viewCompleteSeries: 'View series on OSIMIS',
  viewOHIF: 'View series on OHIF',
  viewStone: 'View series on STONE',
  webViewer: 'Web viewer',
  verMais: '',
  verMenos: '',
  versionsTitle: 'Versions',
  version: 'Version',
  weNeedToMakeDureYouAreYourself: 'Cool, we need to make sure you are yourself',
  weSendATokenCodeToYourEmail: 'We send a token code to your email',
  weight: 'Weight',
  wellAerated: 'Well-Aerated',
  whenAgreeResultsMeansAgreeWithSegmentationAndClassification:
    'When you agree with the results it means that you agree with the segmentation of the parenchyma and the classification given.',
  xa: 'X-Ray Angiography',
  xc: 'External-camera Photography',
  year: 'year',
  years: 'years',
  yesIDo: 'Yes, I do',
  youCanChooseMoreExamToRegister:
    'You can choose more than one exam to register',
  youCanEditAdminInfoBelow: 'You can edit the administrator informations below',
  yourReviewWasSentSucessfully: 'Your review was sent sucessfully',
  yourOpinion: 'Your opinion is valuable to us.',

  zipCode: 'Zip code',
  //cadastrar
  firstAcess: 'First Access',
  helloWelcome: 'Hello, welcome to the HealthScan platform.',
  enterInformation: 'Enter the information below to create your login.',

  typeYourName: 'Enter your name',
  typeYourLastName: 'Enter your last name',
  typeYourConstitutionalEmail: 'Enter the e-mail registered by your institution',
  typeYourCPF: 'Enter your CPF',
  createAPassword: 'Create a password',
  confirmYourPassword: 'Confirm your password',
  passwordInstructions: 'It must be alphanumeric, containing at least 6 characters, with at least one uppercase letter and at least one special character',
  agreeWithTerms: 'Agree with',
  agreeWithTermsOfService: 'Terms and Conditions of Use',
  agreeWithPolicy: 'Privacy and Security Policy',

  firstNameRequired: 'First name required',
  lastNameRequired: 'Last name required',
  validEmailRequired: 'Valid e-mail required',
  passwordMinLength: 'Password must be at least 8 characters long.',
  passwordUppercase: 'Password must contain at least one uppercase letter.',
  passwordLowercase: 'Password must contain at least one lowercase letter.',
  passwordNumber: 'Password must contain at least one number.',
  passwordSpecialChar: 'Password must contain at least one special character, such as !@#%^&*.()',
  passwordsDoNotMatch: 'Passwords do not match',
  passwordRequired: 'Password required',
  validCpfRequired: 'Valid CPF required',
  acceptanceRequired: 'Acceptance required',

  alreadyHaveAccount: 'Already have an account?',
  loginHere: 'Log in here',
  logout: 'Logout',

  //redefinição de senha
  emailInvalid: 'Please enter a valid e-mail.',
  emailError: 'Error sending the request. Please try again.',
  emailNotRegistered: 'E-mail not registered in Healthscan.',
  requestSent: 'Request sent! Check your email to reset your password.',
  passwordReset: 'Password reset successfully! You can now log in.',
  errorPasswordReset: 'Error resetting the password. Please try again.',
  requestPassword: 'Request password',
  requestPasswordInstructions: 'Fill in your email, and you will receive the necessary information to reset your password.',
  requestReset: 'Request reset',

  resetPassword: 'Reset Password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',

  // windowing presets
  preset_lungs1: 'Lungs [W:1600 L:-400]',
  preset_lungs2: 'Lungs [W:1500 L:-600]',
  preset_mediastinum: 'Mediastinum [W:350 L:50]',
  preset_abdomen: 'Abdomen [W:400 L:60]',
  preset_bones: 'Bones [W:1500 L:300]',
  preset_chest: 'Chest [W:400 L:40]',
  preset_angio: 'Angio [W:600 L:300]',

  //anotador
  any: 'Annotation filter',
  brain: 'Brain',
  bones:'Bones',
  mediastinum: 'Mediastinum',
  lungs: 'Lungs',
  softtissue: 'Soft Tissue',

  point: 'Point (2D)',
  sphere: 'Sphere (3D)',

  normal: 'Normal Attenuation',
  high: 'High Attenuation',
  low: 'Low Attenuation',
  subpleural: 'Subpleural Line (SpL)',
  reticular: 'Reticular (Ret)',
  nodular: 'Nodular (Nodr)',
  osteoporosis: 'Osteoporosis',
  ground: 'Ground Glass (GG)',
  honeycombing: 'Honeycombing (Hon)',
  centrilobular: 'Centrilobular Nodule (Cen)',
  linear: 'Linear Scar (Lin)',
  cyst: 'Cyst (Cyst)',
  fibronodular: 'Fibronodular (Fib)',
  crazy: 'Crazy Paving (CP)',
  consolidation: 'Consolidation (Cons)',
  bronchiectasis: 'Bronchiectasis',
  bronchiolectasis: 'Bronchiolectasis',
  myosteatosis: 'Myosteatosis',

  basal: 'Basal Subpleural Reticular Pattern',
  thickening: 'Thickening of Interlobular Septa',
  dorsalgroundglass: 'Ground-Glass Opacities in Posterior and Dorsal Fields',
  periosteofitary: 'Periosteofitary Ground-Glass Opacities',
  thincysts: 'Thin-Walled Airspace Cysts',
  bronchial: 'Bronchial Wall Thickening',
  bronchialdilation: 'Bronchial Ectasia/Dilation',
  tracheobronchialcalcifications: 'Calcifications of Tracheobronchial Cartilages',
  fibrostreaks: 'Fibroatelectatic Streaks',
  subsegmentalatelectasis: 'Subsegmental Atelectasis',
  parenchymalbands: 'Parenchymal Bands',
  centrilobularemphysema: 'Centrilobular Emphysema',
  subpleuralemphysema: 'Subpleural Emphysema',
  paraseptalemphysema: 'Paraseptal Emphysema',
  pulmonarycavitation: 'Pulmonary Cavitation',
  deformity: 'Tracheal Deformity',

  
  smallernodules: 'Nodules Smaller than 6 mm',
  largernodules: 'Nodules Larger than 6 mm',
  granulomas: 'Granulomas (Calcified Micronodules)',
  pleuralthickening: 'Pleural Thickening',
  pleuralplaques: 'Pleural Plaques',
  pleuraleffusion: 'Pleural Effusion',
  diaphragmatichernia: 'Diaphragmatic Hernia',
  diaphragmaticfolds: 'Diaphragmatic Folds',
  ascendingaortadilation: 'Ectasia/Dilation of the Ascending Aorta (> 30 mm)',
  ascendingaortacalcifications: 'Calcifications of the Ascending Aorta',
  descendingaortacalcifications: 'Calcifications of the Descending Aorta',
  coronary: 'Coronary Calcifications',
  dorsal: 'Dorsal Spine Spondylosis',
  hepatic: 'Hepatic Steatosis',
  hepatomegaly: 'Hepatomegaly',
  splenomegaly: 'Splenomegaly',

  // Predominant infiltrate type
  heterogenousopacity: 'Heterogeneous Opacity',
  homogeneousopacitywithoutaerobroncogram: 'Homogeneous Opacity without Aerobroncogram',
  opacitywithaerobroncogram: 'Opacity with Aerobroncogram',
  cavitation: 'Cavitation',
  diffusereticularnodularinfiltrate: 'Diffuse Reticular-nodular Infiltrate',
  localizedreticularnodularinfiltrate: 'Localized Reticular-nodular Infiltrate',
  reticularinterstitialinfiltrate: 'Reticular Interstitial Infiltrate',
  singlecalcifiednodule: 'Single Calcified Nodule',
  singlenoncalcifiednodule: 'Single Non-calcified Nodule',
  smallnodules: 'Small Nodules',
  structuralchangesretractiveaspatct: 'Structural Changes with Retractile Aspect',
  bullae: 'Bullae',
  fibroatelectasis: 'Fibroatelectasis',
  segmentalatelectasis: 'Segmental atelectasis',
  subsegmentalatelectasis: 'Subsegmental atelectasis',
  laminaratelectasis: 'Laminar atelectasis',

  // Pleural commitment
  pleuraleffusionuptofiventhrib: 'Pleural Effusion up to 5th Rib',
  pleuraleffusionuptothirdrib: 'Pleural Effusion up to 3rd Rib',
  pleuraleffusionabovethirdrib: 'Pleural Effusion above 3rd Rib',
  obscurationofcostophrenicsinus: 'Obscuration of Costophrenic Sinus',

  // Lesions
  militarytuberculosis: 'Military Tuberculosis',
  pericardialeffusion: 'Pericardial Effusion',

  // Lymphadenopathy
  hilarlymphadenopathy: 'Hilar',
  mediastinallymphadenopathy: 'Mediastinal',

  predominantInfiltrateType: 'Predominant infiltrate type',
  pleuralCompromise: 'Pleural commitment',
  lesions: 'Lesions',
  lymphadenopathy: 'Lymphadenopathy',

  opportunisticScreeningChestCT: 'Opportunistic screening in Chest Tomography',
  findingsChestCTElderly: 'Findings on Chest Tomography in the Elderly',
  disease: 'Disease', 
  attenuationPattern: 'Attenuation Pattern',

  uploadSuccess: 'The mask has been successfully sent to server',
  uploadError: 'It was not possible to send the mask to the server',

  undoMaskChanges: 'Undo changes',
  areYouSureUndoMaskChanges: 'Are you sure you wanna to undo all mask changes?',
  afterConfirmationUndoMaskChanges: 'After confirmation, the changes will be completely erased',
};

export default en;
